import { gql } from "@apollo/client";

const PAIRING_RESULT_FRAGMENT = gql`
  fragment PairingResultFields on PairingResultType {
    id
    status
    passLevel
    failureReason
    rating
    feedbackTags
    feedbackText
    feedbackSubmittedDate
    brief {
      mealSummary
      wineClass
      body
      acidity
      tannin
      sweetness
      grapeHints
      regionHints
      avoid
      rationale
    }
    slots {
      slot
      personalMatch
      pairingFit
      pairingNote
      recommendationExplanation {
        id
        explanation
        rating
        feedbackText
        feedbackTags
        feedbackSubmittedDate
      }
      wine {
        id
        year
        shortDescription
        sommelierNotes
        memberLikelihood
        wineMaker {
          id
          name
        }
        country {
          id
          name
        }
        product {
          id
          name
          slug
          sellingPrice
          coverPhotoSmall
          productType {
            id
          }
        }
        wineType {
          id
          name
          wineClass {
            id
            name
          }
        }
        wineRegion {
          id
          name
        }
        winePriceRange {
          id
        }
      }
    }
  }
`;

export const PAIR_WINE_FOR_MEAL = gql`
  mutation PairWineForMeal($mealText: String!, $winePriceRangeIds: [Int]) {
    pairWineForMeal(mealText: $mealText, winePriceRangeIds: $winePriceRangeIds) {
      ...PairingResultFields
    }
  }
  ${PAIRING_RESULT_FRAGMENT}
`;

export const GET_PAIRING_RESULT = gql`
  query PairingResult($id: UUID!) {
    pairingResult(id: $id) {
      ...PairingResultFields
    }
  }
  ${PAIRING_RESULT_FRAGMENT}
`;

export const SUBMIT_PAIRING_FEEDBACK = gql`
  mutation SubmitPairingFeedback($input: SubmitPairingFeedbackInput!) {
    submitPairingFeedback(input: $input) {
      pairingResult {
        ...PairingResultFields
      }
      errors {
        field
        messages
      }
    }
  }
  ${PAIRING_RESULT_FRAGMENT}
`;
